import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  getClarityMode, getConsent, setConsent, syncClarity, OPEN_CONSENT_EVENT, CONSENT_EVENT,
} from '../utils/clarity';

export const ClarityTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => { syncClarity(pathname); }, [pathname]);
  useEffect(() => {
    const onChange = () => syncClarity(window.location.pathname);
    window.addEventListener(CONSENT_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_EVENT, onChange);
  }, []);
  return null;
};

const btn = { padding: '9px 18px', borderRadius: 999, fontSize: 13, fontWeight: 600, cursor: 'pointer' };

export const AnalyticsConsentBanner = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(() => getClarityMode() !== 'off' && !getConsent());

  useEffect(() => {
    const reopen = () => setOpen(true);
    window.addEventListener(OPEN_CONSENT_EVENT, reopen);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, reopen);
  }, []);

  if (!open || pathname.startsWith('/admin')) return null;

  const choose = (value) => { setConsent(value); setOpen(false); };

  return (
    <div role="dialog" aria-label="Analytics cookie choice" data-testid="analytics-consent-banner"
      style={{
        position: 'fixed', left: 16, bottom: 16, zIndex: 9995, maxWidth: 420, width: 'calc(100% - 32px)',
        background: '#0A1F44', color: '#E5ECF5', border: '1px solid rgba(0,229,255,0.3)', borderRadius: 14,
        padding: '16px 18px', boxShadow: '0 10px 30px rgba(0,0,0,0.35)', fontSize: 13, lineHeight: 1.5,
      }}>
      <p style={{ margin: 0 }}>
        With your permission, we use Microsoft Clarity analytics cookies to see how visitors use our site so we can improve it.
        Typed text is masked, and checkout and account pages are never recorded.{' '}
        <Link to="/cookie-policy" style={{ color: '#00E5FF', textDecoration: 'underline' }} data-testid="consent-cookie-policy-link">
          Cookie Policy
        </Link>
      </p>
      <div style={{ display: 'flex', gap: 10, marginTop: 12, flexWrap: 'wrap' }}>
        <button type="button" data-testid="consent-accept-btn" onClick={() => choose('granted')}
          style={{ ...btn, background: '#00E5FF', color: '#0A1F44', border: 'none' }}>
          Accept analytics
        </button>
        <button type="button" data-testid="consent-decline-btn" onClick={() => choose('denied')}
          style={{ ...btn, background: 'transparent', color: '#E5ECF5', border: '1px solid rgba(229,236,245,0.5)' }}>
          Decline
        </button>
      </div>
    </div>
  );
};
